import React, { useState } from 'react';
import { Provider } from 'react-redux';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

import configureStore from 'modules/store';

export default function HistoryProvider(props) {
  const history = useHistory();

  const [store] = useState(configureStore({ history }));

  return <Provider store={store}>{props.children}</Provider>;
}

HistoryProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
